/**
 * InstaXchange hosted-checkout embed.
 *
 * 🩹 Iter49 (Jun-2026) — root cause of the "Banxa spinner hang" customer
 * complaint (Lydia): InstaXchange's docs (instaxchange.com/iframe-session.html)
 * explicitly state since Sep 16 2025 that **only the iframe flow is
 * supported**. We had been opening their hosted URL via `window.open(_, "_blank")`
 * or same-tab redirect (the legacy widget flow), which their backend now
 * silently fails on `/payment_session/<id>/init` — page shows the spinner
 * forever, customer eventually closes the tab. When we embed the same URL
 * in an iframe with the documented attributes, `/init` auto-fires with
 * `device_data` from the browser, returns 200, and redirects internally to
 * Banxa's "Add your details" page. Verified end-to-end against InstaXchange's
 * own reference example.
 *
 * Iframe attributes mirror their docs verbatim; `allow-top-navigation` in
 * the sandbox lets InstaXchange/Banxa navigate the PARENT tab to our
 * `returnUrl` (e.g. `/widget/status/<orderId>`) when the customer finishes.
 *
 * @param {string} url   — the InstaXchange hosted-checkout URL
 *                        (`https://instaxchange.com/order/ps_...`).
 * @param {string} title — accessible label for screen readers.
 * @param {string} testid — data-testid for QA hooks.
 */
import React from "react";

export default function InstaxIframe({ url, title = "InstaXchange checkout", testid = "instax-iframe" }) {
  if (!url) return null;
  return (
    <iframe
      src={url}
      title={title}
      data-testid={testid}
      allow="clipboard-read; clipboard-write; fullscreen; payment; camera"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation"
      referrerPolicy="strict-origin-when-cross-origin"
      style={{ width: "100%", height: "100%", border: 0, minHeight: "720px", display: "block" }}
    />
  );
}
